import script from "./AppCell.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCell.vue?vue&type=script&setup=true&lang=js"

import "./AppCell.vue?vue&type=style&index=0&id=74df10d8&scroped=true&lang=css"

const __exports__ = script;

export default __exports__